import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackJourneyEvent } from "@/lib/analytics";
import { initVisitorTracking, isNewSession, captureSourceNeighborhood, getVisitorId } from "@/lib/visitorTracking";

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

/** Fires a page_view journey event on every route change, plus session_start once per session. */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initVisitorTracking();
    captureSourceNeighborhood(location.pathname, location.search);
    if (isNewSession()) {
      trackJourneyEvent("session_start", { entry_path: location.pathname });
    }
    // Small delay so document.title has updated for the new route.
    const t = setTimeout(() => {
      trackJourneyEvent("page_view", {
        path: location.pathname,
        search: location.search || null,
      });

      // Tell Microsoft Clarity about the SPA route change and tag it with our
      // first-party visitor_id so recordings can be cross-referenced with
      // engagement_events (which survive ad blockers).
      try {
        if (typeof window !== "undefined" && typeof window.clarity === "function") {
          const vid = getVisitorId();
          if (vid) window.clarity("identify", vid);
          window.clarity("set", "page", location.pathname);
          window.clarity("event", "spa_page_view");
        }
      } catch { /* clarity blocked or not loaded — first-party tracking already fired */ }
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;